export const FILTER_KEY_PROP = 'filterKey'
export const FILTER_LABEL_OVERRIDE_PROP = 'filterLabelOverride'

export type BaseFilterProps = {
  [FILTER_KEY_PROP]: string
  [FILTER_LABEL_OVERRIDE_PROP]?: string
}
